import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-e-leaf",
  "use": "icon-e-leaf-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" id=\"icon-e-leaf\"><path d=\"M18 1C17.8236 12.9433 13.1761 19 5.99903 15.093M18 1C8.59014 1 -0.0181812 9.37209 5.99903 15.093M18 1C14.294 3.65116 7.50626 10.3488 5.99903 15.093M5.99903 15.093C5.65944 16.1619 5.42963 17.8837 5.42963 19\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol